import { render, staticRenderFns } from "./ModalPromotion.vue?vue&type=template&id=6843f232&scoped=true"
import script from "./ModalPromotion.vue?vue&type=script&lang=js"
export * from "./ModalPromotion.vue?vue&type=script&lang=js"
import style0 from "./ModalPromotion.vue?vue&type=style&index=0&id=6843f232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6843f232",
  null
  
)

export default component.exports